import script from "./EmployeesWithHolidaysNew.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesWithHolidaysNew.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesWithHolidaysNew.vue?vue&type=style&index=0&id=5854fb2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5854fb2c"]])

export default __exports__